import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InterventionTeamsNavigationComponent} from './intervention-teams-navigation.component';
import {RouterModule} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";
import {NavbarModule} from "ng-uikit-pro-standard";


@NgModule({
  declarations: [
    InterventionTeamsNavigationComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    NavbarModule,
  ]
})
export class InterventionTeamsNavigationModule {
}
